module.exports = {"label":{"client":"Client","inactive":"Inaktive Clients"},"validation":{"client":{"required":"Bitte wählen Sie einen Client aus"}}}